import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import cx from 'classnames';
import { SIMPLE_VALUE_PROP } from 'ui/consts/prop-types';
import { wire } from './prop-wire';

var log = require('loglevel').getLogger('search');
/**
A React SearchBar
 * @constructor
 * @param {string} [id] - container element #id
 * @param {string} [className] - Classname for the container
 * @param {string|number} [defaultValue] - Default search value
 * @param {string|number} [value] - Current search value
 * @param {string} [placeholder] - Placeholder for search input
 * @param {boolean} [interactive=false] - Determine if search is interactive<br>
 * true: onSearch event called as user types; <br>
 * false: onSearch event called when user hits enter
 * @param {function} [onSearch] - Callback function when search is changed. <br> Required when value prop is supplied
 * @param {string|number} onSearch.search - updated search value
 * @param {string} [searchIconPosition] - It's use to show icon position. Options: left, right
 *
 * @example

import SearchBar from 'core/components/search'

React.createClass({
    getInitialState() {
        return {
            movies:[]
        }
    },
    handleSearch(search) {
        // after ajax request get back list of movies
        let movies = ['My big fat greek wedding','Starlight Hotel']
        this.setState({movies})
    },
    render() {
        let {movies} = this.state;
        return <div>
            <SearchBar placeholder='Please enter movie title' onSearch={this.handleSearch}/>
            <div>
            {
                _.map(movies, (movie, i)=>`${i}. ${movie}`)
            }
            </div>
        </div>
    }
})
 */


var SearchBar = createReactClass({
  displayName: "SearchBar",
  propTypes: {
    id: PropTypes.string,
    className: PropTypes.string,
    placeholder: SIMPLE_VALUE_PROP,
    value: SIMPLE_VALUE_PROP,
    onSearch: PropTypes.func.isRequired,
    interactive: PropTypes.bool,
    searchIconPosition: PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      interactive: false,
      searchIconPosition: 'left'
    };
  },
  getInitialState: function getInitialState() {
    var value = this.props.value;
    return {
      value: value
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var value = nextProps.value;
    this.setState({
      value: value
    });
  },
  focus: function focus() {
    this.input.focus();
  },
  handleSearch: function handleSearch(force) {
    var value = this.input.value;
    var _this$props = this.props,
        interactive = _this$props.interactive,
        onSearch = _this$props.onSearch;
    if (force || interactive) onSearch(_.trim(value));else this.setState({
      value: value
    });
  },
  handleKeyDown: function handleKeyDown(e) {
    if (e.keyCode === 13) this.handleSearch(true);
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        id = _this$props2.id,
        className = _this$props2.className,
        placeholder = _this$props2.placeholder,
        searchIconPosition = _this$props2.searchIconPosition;
    var value = this.state.value;
    return /*#__PURE__*/React.createElement("span", {
      id: id,
      className: cx('c-search c-custom-input', searchIconPosition === 'left' ? 'left-search-icon' : '', className)
    }, /*#__PURE__*/React.createElement("input", {
      ref: function ref(_ref) {
        _this.input = _ref;
      },
      type: "text",
      value: value,
      placeholder: placeholder,
      onKeyDown: this.handleKeyDown,
      onChange: this.handleSearch.bind(this, false)
    }), /*#__PURE__*/React.createElement("i", {
      className: cx('c-link fa fa-search inline', searchIconPosition === 'left' ? 'left-icon' : ''),
      onClick: this.handleSearch
    }));
  }
});
export default wire(SearchBar, 'value', '', 'onSearch');